// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let facilityTypeEnum = {
    'Harvesting': 1,
    'Packing': 2,
    'Other': 4
};

export default facilityTypeEnum;
